
import React from 'react';

import { ParameterListBase } from '../../core';

import getParameterDefinitionsWithGeom from './getParameterDefinitionsWithGeom';

const ParameterListWithGeom = ({
    generatePolygonDefinition,
    options,
    params,
    paramValues,
    tempFeature,
    onConfirm,
    onChangeValue,
    onSetGeometry,
    onSetIsGeoActive
}) => {

    return (
        <ParameterListBase
            paramDefinitions={getParameterDefinitionsWithGeom()}
            generatePolygonDefinition={generatePolygonDefinition}
            options={options}
            params={params}
            paramValues={paramValues}
            tempFeature={tempFeature}
            onConfirm={onConfirm}
            onChangeValue={onChangeValue}
            onSetGeometry={onSetGeometry}
            onSetIsGeoActive={onSetIsGeoActive}
        />
    );
}

export default ParameterListWithGeom;
